import ArticleDisclaimer from '@/components/ArticleDisclaimer';
import { createBlock } from '@/lib/parsers/blocks';
import { BlockContainer } from '../../BlockContainer';

const ArticleDisclaimerStatementBlock = createBlock<'blocks_articleDisclaimerStatement_BlockType'>(
  ({ _blockMeta: meta }) => {
    return (
      <BlockContainer meta={meta} disableTransition>
        <ArticleDisclaimer />
      </BlockContainer>
    );
  }
);

export default ArticleDisclaimerStatementBlock;
